// extracted by mini-css-extract-plugin
module.exports = {"root":"Placeholder_root__3oGXR"};